const AOA = 'AOA';

const symbolOfCurrencies = {
  [AOA]: 'Kz',
};

const getSymbolOfCurrency = (currencyName) => symbolOfCurrencies[currencyName];

export default getSymbolOfCurrency;
